import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix Leaflet default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });

  return position === null ? null : <Marker position={position} />;
}

export default function MapPicker({ lat, lng, onLocationChange, className = '' }) {
  const [position, setPosition] = useState(
    lat && lng ? { lat, lng } : { lat: 9.3068, lng: 123.3054 } // Default: Dumaguete, Philippines
  );

  const handlePositionChange = (newPos) => {
    setPosition(newPos);
    if (onLocationChange) {
      onLocationChange(newPos.lat, newPos.lng);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <MapContainer
        center={position}
        zoom={13}
        style={{ height: '400px', width: '100%', borderRadius: '8px' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker position={position} setPosition={handlePositionChange} />
      </MapContainer>
      <div className="mt-2 text-xs text-gray-600">
        Click on the map to set your business location. Current: {position.lat.toFixed(6)}, {position.lng.toFixed(6)}
      </div>
    </div>
  );
}
